// treatmentLabel names a treatment where its lengths must be told apart:
// "Sculpt & Define · 90 min" when the service has more than one length, else
// the plain name. The name snapshot never carries the duration (spec §2.1).
export function treatmentLabel(name: string, minutes: number, lengthCount: number): string {
  return lengthCount > 1 ? `${name} · ${minutes} min` : name
}
